import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold w-200px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }, "Manage")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_4 = { class: "menu-item px-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add User ")
const _hoisted_6 = { class: "menu-item px-3" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Add Role ")
const _hoisted_8 = {
  class: "menu-item px-3",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "left-start, top"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "menu-link px-3"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Add Group"),
  /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
], -1)
const _hoisted_10 = { class: "menu-sub menu-sub-dropdown w-200px py-4" }
const _hoisted_11 = { class: "menu-item px-3" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Admin Group ")
const _hoisted_13 = { class: "menu-item px-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Staff Group ")
const _hoisted_15 = { class: "menu-item px-3" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Member Group ")
const _hoisted_17 = { class: "menu-item px-3" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Reports ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_20 = { class: "menu-item px-3" }
const _hoisted_21 = { class: "menu-content px-3 py-3" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Create New ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        to: "/settings",
        class: "menu-link px-3"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: "/settings",
        class: "menu-link px-3"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            to: "/settings",
            class: "menu-link px-3"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: "/settings",
            class: "menu-link px-3"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: "/settings",
            class: "menu-link px-3"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_router_link, {
        to: "/settings",
        class: "menu-link px-3"
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ]),
    _hoisted_19,
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary fw-bold btn-sm px-4",
          to: "/settings"
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ])
    ])
  ]))
}